module.exports = __webpack_public_path__ + "static/img/areaA-24.b57196b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-24.png
// module id = 936
// module chunks = 1